export default "__VITE_ASSET__3866d7b2__"